import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MediaPrice from '../../private-pages/messages/media-price';
import Duration from '../Duration';
import { s3Link } from '../../utils/constants';
import { connect, useDispatch } from 'react-redux';
import dateFormat from 'dateformat';
import { checkAspectRatio } from '../../utils/helper';
import React, { useState, useEffect, forwardRef } from 'react';
import { setStash, setStashSelectedR, setTempSelected } from '../../../redux/actions/stash';
import { setAlert } from '../../../redux/actions';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const StashItem = forwardRef(({
    item,
    broadcastModal,
    mediaSold,
    mediaSent,
    stashSidebar,
    stashSelected,
    stash,
    mediaFiles,
    source,
    tabSelected,
    albumAction,
    max = 0,
    tempSelected
}, ref) => {
    const dispatch = useDispatch();

    const [deletedMessagePrice, setDeletedMessagePrice] = useState({});
    const [activeStashItem, setActiveStashItem] = useState({});
    const [editAlbumSelected, setEditAlbumSelected] = useState([]);

    useEffect(() => {
        let mounted = true;
        if (deletedMessagePrice && Object.keys(deletedMessagePrice).length > 0) {
            const tmpFiles = [...mediaFiles];
            const index = tmpFiles.findIndex(file => file.media_id === activeStashItem.media_id);
            if (index >= 0) {
                if (tmpFiles[index].messages && tmpFiles[index].messages.length > 0) {
                    tmpFiles[index].messages[0] = deletedMessagePrice;
                } else {
                    tmpFiles[index].messages = [deletedMessagePrice];
                }
                tmpFiles[index].latest_price = deletedMessagePrice.price;
            }

            dispatch(setStash({
                ...stash,
                medias: [...tmpFiles]
            }));
        }

        return () => {
            mounted = false;
        };
    }, [deletedMessagePrice]);

    const openModalImage = (e) => {
        const el = e.target;
        if (el) {
            el.classList.add("cust-fancybox");
            el.click();
            el.classList.remove("cust-fancybox");
        }
    };

    const openModalVideo = (media) => {
        const img = media.large_path ? media.large_path : media.thumb_path;
        const aspectRatio = checkAspectRatio(media.aspect_ratio);
        const payload = {
            showVideoModal: true,
            imageModalSource: img,
            containerClass: aspectRatio,
            videoModalSource: media.file_path
        };
        dispatch(setStash({
            ...stash,
            ...payload
        }));
    };

    const addSelectStash = () => {
        let selected = [...stashSelected];
        const index = selected.findIndex(select => select.media_id === item.media_id);
        const stashTempSelected = [...tempSelected];

        if (index >= 0) {
            selected.splice(index, 1);
        } else {
            if (max > 0 && max <= selected.length) {
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: `Maximum of ${max} media selection allowed`
                }));
            } else {
                stashTempSelected.push(item.media_id);
                selected.push(item);
            }
        }

        dispatch(setTempSelected([...stashTempSelected]));
        dispatch(setStashSelectedR([...selected]));
    };

    const isPurchasedViaPost = (post, media_src) => {
        if (post.length > 0 && media_src === 'post_st') {
            if (
                post[0].pu_id !== parseInt(localStorage.getItem('other_user'))
                && post[0].unlocked === true
                && post[0].price > 0
                && mediaSold.includes(post[0].pivot.media_id)
            ) {
                return 'SOLD POST';
            } else {
                return 'POST';
            }
        }

        return '';
    };

    const isPurchasedViaMessenger = (messages, item) => {
        if (
            mediaSold
            && !broadcastModal
            && messages && messages.length > 0
            && messages[0].reciever
            && messages[0].transactions.length > 0
            && mediaSold.includes(item.media_id)
            && parseInt(messages[0].transactions[0].from_pay_userid) === parseInt(localStorage.getItem('other_user'))
        ) {
            return 'SOLD';
        }

        return '';
    };

    const checkIfItemWasPurchased = (item) => {
        let response = isPurchasedViaMessenger(item.messages, item);

        if (response !== 'SOLD' && item.posts && item.posts.length > 0) {
            response = isPurchasedViaPost(item.posts, item.media_src);
        }

        return response;
    };

    return <div
        ref={ref}
        className={`stash-item${(mediaSent.find(element => element === item.media_id) && !stashSidebar && !broadcastModal) ? ' sent-media' : ''}`}
    >
        <div
            className="stash-item-date"
            onClick={addSelectStash}
        >
            {dateFormat(item.created_at, "mmm d, yyyy")}
        </div>
        {
            !stashSidebar
            && ((tabSelected === 'album' && albumAction === 'view_album') || ['messenger'].includes(source))
            && <div className="stash-sold-label font-blue text-center">{checkIfItemWasPurchased(item)}</div>
        }
        {item.type.toLowerCase() === 'video' &&
            <div className="stash-vid" onClick={() => openModalVideo(item)}>
                <div className="stash-vid-icon">
                    <FontAwesomeIcon icon={['fas', 'play']} />
                </div>
            </div>
        }
        <div
            className={`stash-item-img ${item.media_id}`}
            // style={{ backgroundImage: `url('${s3Link}/${item.thumb_path}')` }}
            onClick={addSelectStash}
        >
            <LazyLoadImage
                src={`${s3Link}/${item.thumb_path}`}
                effect="opacity"
                className="img-fluid"
                style={{ zIndex: '-1', width: '100%', height: '100%', objectFit: 'cover' }}
            />
            <span
                className={"img_select " + (stashSelected && stashSelected.find(element => element.media_id == item.media_id) ? 'selected' : '') + ((editAlbumSelected.find(element => element === item.media_id) && mediaOrAlbum == 'view_album' && isAddingToAlbum) ? ' selected valbum_test' : '')}></span>
        </div>

        {item.type.toLowerCase() === 'image' &&
            <div
                className="stash-zoom-icon"
                onClick={(e) => openModalImage(editAlbumSelected)}
                data-src={`${s3Link}/${item.file_path}`}
                data-fancybox={'stash-media-slider' + `${item.media_id}`}
                data-protect="true"
            >
                <i className="fa-solid fa-magnifying-glass"></i>
            </div>}

        {item.type.toLowerCase() === 'video' && <Duration duration={item.vid_duration} />}
        {
            item.latest_price !== null && <MediaPrice
                media={item}
                setActiveStashItem={setActiveStashItem}
                setDeletedMessagePrice={setDeletedMessagePrice}
            />
        }
    </div>;
});

const mapStateToProps = state => {
    return {
        stash: state.stash,
        broadcastModal: state.message.broadcastModal,
        mediaSold: state.stash.mediaSold,
        mediaSent: state.stash.mediaSent,
        stashSidebar: state.stash.stashSidebar,
        stashSelected: state.stash.stashSelected,
        mediaFiles: state.stash.medias,
        tabSelected: state.stash.tabSelected,
        albumAction: state.stash.albumAction,
        tempSelected: state.stash.tempSelected
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(React.memo(StashItem));
